module.exports = __webpack_public_path__ + "img/181.4a04f9cd.jpg";